import { getApproximatedValue } from './getApproximatedValue';
export const getGoalProgress = ({ input, goalValue, t }) => {
    let diff;
    if (goalValue === 0) {
        return t('DIV/0');
    }
    if ((input > 0 && goalValue > 0) || (input < 0 && goalValue < 0)) {
        diff = Math.abs(input / goalValue);
    }
    else {
        diff = input / goalValue - 1;
    }
    const percent = getApproximatedValue(diff * 100);
    return `${percent}${t('% of goal')}`;
};
